const GLIMMR_SECRET_KEY = "e8djsi91ncjasd78329-kdsldjshal9012";
const GITHUB_API_KEY = "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";
const GITHUB_USER = "carlelieser";
const POSTMARK_SERVER_TOKEN = "e0d5287f-c57a-49b1-ac1f-4610ac30dacb";
const SMTP_USER = "support@glimmr.app";
const SMTP_FROM = "Glimmr <support@glimmr.app>";
const LICENSE_MIN_PRICE = "1.99";
const LICENSE_MAX_PRICE = "5.99";
const STRIPE_SECRET_KEY = "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";
const STRIPE_PRODUCT_ID = "prod_RV174P8sBonywM";
const STRIPE_WEBHOOK_SECRET = "whsec_w8XMMpIbUQJ4pXG9iMAcKsBfeqx8z6Tk";
export {
  GITHUB_USER as G,
  LICENSE_MIN_PRICE as L,
  POSTMARK_SERVER_TOKEN as P,
  STRIPE_PRODUCT_ID as S,
  GITHUB_API_KEY as a,
  LICENSE_MAX_PRICE as b,
  STRIPE_WEBHOOK_SECRET as c,
  SMTP_USER as d,
  SMTP_FROM as e,
  STRIPE_SECRET_KEY as f,
  GLIMMR_SECRET_KEY as g
};
